export default {
  shortNames: {
    CADDIE_DOMAINS: [ 'CG_DK', 'CG_SE', 'CG_NO' ],
    BE_ACTIVE_AWAY_DOMAINS: [ 'BA_DK' ],
    ELCANO: 'EL',
  },
};



// WEBPACK FOOTER //
// ./src/variables/domains.js